export default {
  name: "development",
  api: {
    baseUrl: "https://development.api.layapp.jp",
  },
};
